import { combineEpics } from "redux-observable";
import { filter, mergeMap } from "rxjs/operators";

import { actionCreators, isOfAction } from "../actions";
import { getOpenRoomIds, RoomType } from "../reducers/rooms";
import { Epic } from "../utils/types";

const onOnNotificationClicked: Epic = (action$, state$) => {
    return action$.pipe(
        filter(isOfAction(actionCreators.onNotificationClicked)),
        mergeMap(({ payload: roomId }) => {
            const openRooms = getOpenRoomIds(state$.value);
            if (!openRooms.includes(roomId)) {
                return [
                    actionCreators.setRoomToOpen({
                        roomId,
                        type: RoomType.REAL_TIME,
                    }),
                ];
            }
            return [];
        })
    );
};

export const notificationsEpic = combineEpics(
    //
    onOnNotificationClicked
);
